$('.hero .slider').slick({
    dots: true,
    appendDots: '.hero .dots',
    arrows: true,
    appendArrows: '.hero .arrows',
    infinite: true,
    slide: '.hero .slide',
});